import { render, staticRenderFns } from "./addgrid.vue?vue&type=template&id=10d59b45&scoped=true&"
import script from "./addgrid.vue?vue&type=script&lang=js&"
export * from "./addgrid.vue?vue&type=script&lang=js&"
import style0 from "./addgrid.vue?vue&type=style&index=0&id=10d59b45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d59b45",
  null
  
)

export default component.exports